module.exports = __webpack_public_path__ + "static/media/figli.e8e2781d.jpg";